import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import 'reflect-metadata';

 const CLASS_VALIDATOR_METADATA_KEY = Symbol('classValidatorMetadata');

interface ClassValidatorConfig {
  validators: ValidatorFn[];
}

 function ClassValidatorConfig(config: ClassValidatorConfig) {
  return function (target: any) {
    // 既存のバリデーターを取得し、新しいバリデーターと結合
    const existingValidators = Reflect.getMetadata(CLASS_VALIDATOR_METADATA_KEY, target) || [];
    Reflect.defineMetadata(CLASS_VALIDATOR_METADATA_KEY, [...existingValidators, ...config.validators], target);
  };
}
export { ClassValidatorConfig, CLASS_VALIDATOR_METADATA_KEY };